'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var $schema = "http://json-schema.org/draft-07/schema";
var $id = "SystemV1alpha1";
var description = "A system is a collection of resources and components. The system may expose or consume one or several APIs. It is viewed as abstraction level that provides potential consumers insights into exposed features without needing a too detailed view into the details of all components. This also gives the owning team the possibility to decide about published artifacts and APIs.";
var examples = [
	{
		apiVersion: "backstage.io/v1alpha1",
		kind: "System",
		metadata: {
			name: "artist-engagement-portal",
			description: "Handy tools to keep artists in the loop"
		},
		spec: {
			owner: "artist-relations-team",
			domain: "artists",
			type: "service"
		}
	}
];
var allOf = [
	{
		$ref: "Entity"
	},
	{
		type: "object",
		required: [
			"spec"
		],
		properties: {
			apiVersion: {
				"enum": [
					"backstage.io/v1alpha1",
					"backstage.io/v1beta1"
				]
			},
			kind: {
				"enum": [
					"System"
				]
			},
			spec: {
				type: "object",
				required: [
					"owner"
				],
				properties: {
					owner: {
						type: "string",
						description: "An entity reference to the owner of the component.",
						examples: [
							"artist-relations-team",
							"user:john.johnson"
						],
						minLength: 1
					},
					domain: {
						type: "string",
						description: "An entity reference to the domain that the system belongs to.",
						examples: [
							"artists"
						],
						minLength: 1
					},
					type: {
						type: "string",
						description: "The type of system. There is currently no enforced set of values for this field, so it is left up to the adopting organization to choose a nomenclature that matches their catalog hierarchy.",
						examples: [
							"product",
							"service",
							"feature-set"
						],
						minLength: 1
					}
				}
			}
		}
	}
];
var jsonSchema = {
	$schema: $schema,
	$id: $id,
	description: description,
	examples: examples,
	allOf: allOf
};

exports.$id = $id;
exports.$schema = $schema;
exports.allOf = allOf;
exports.default = jsonSchema;
exports.description = description;
exports.examples = examples;
//# sourceMappingURL=System.v1alpha1.schema.json.cjs.js.map
